export default "__VITE_ASSET__C2p5J1Rw__"